/**
 * Deep F: a steel strongroom of diamonds inside a moat where two fireflies circle. The jade key
 * opens the inner door, the gold key the outer; time the dash across the moat (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepF: CaveDef = {
  id: 'F',
  name: 'STRONGROOM',
  hint: 'Both keys open the vault. Cross the moat between guards.',
  intermission: false,
  colors: [6, 12, 7],
  diamondValue: 19,
  extraValue: 30,
  fill: { base: '.', items: [['r', 12], ['d', 4]] },
  levels: [
    { seed: 5601, diamonds: 16, time: 160 },
    { seed: 5602, diamonds: 19, time: 150 },
    { seed: 5603, diamonds: 22, time: 140 },
    { seed: 5604, diamonds: 25, time: 130 },
    { seed: 5605, diamonds: 28, time: 120 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W....??????????????????????????????????W',
    'W.P..??????????????????????????????????W',
    'W....2.????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????????????WWWWWWWWWWWWWW????????????W',
    'W????????????W     f      W????????????W',
    'W????????????W WWWWWWWWWW W????????????W',
    'W????????????W Wd.dddd.dW W????????????W',
    'W????????????W Wdddddddd5 4.???????????W',
    'W????????????W Wdd.dd.ddW W????????????W',
    'W????????????W Wd.d..d.dW W????????????W',
    'W????????????W WWWWWWWWWW W????????????W',
    'W????????????W     F      W????????????W',
    'W????????????WWWWWWWWWWWWWW????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???????????????????????????????..1..??W',
    'W.X????????????????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
